import { Component, Input, OnInit } from '@angular/core'

@Component({
    selector: 'app-input-field',
    templateUrl: './input-field.component.html',
    styleUrls: [
        './input-field.component.css',
    ],
})
export class InputFieldComponent implements OnInit {
    @Input() label: string
    @Input() className: string

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/commons/input-field/input-field.component.ts